<mat-form-field
  appearance="outline"
  class="custom-mat-select"
  [ngClass]="classWidth"
>
  <mat-select
    [placeholder]="placeholder"
    [multiple]="multiple"
    [disabled]="disabled"
    [(value)]="selectedValue"
    (selectionChange)="onSelectionChange($event.value)"
  >
    <mat-option
      *ngFor="let option of options"
      [value]="option.id"
      (click)="onOptionClick(option)"
    >
      {{ option.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
